<template>
  <ContainerBasic container-type="PAGE">
    <div class="relative min-h-screen">
      <client-only>
        <iframe
          id="personio-iframe"
          crossorigin="anonymous"
          :src="url"
          width="100%"
          class="min-h-screen border-0 mt-xl scroll-to-form"
          style="border: none"
        ></iframe>
      </client-only>
      <div
        v-show="isLoading"
        class="absolute top-0 left-0 w-full h-full bg-white border border-gray-300 border-solid"
      >
        <div
          class="absolute text-2xl top-[200px] left-0 w-full flex flex-col animate-pulse items-center justify-center"
        >
          <span>{{ t('jobs.loading') }}</span>
          <FaIcon icon-class="fas fa-circle-notch fa-spin mx-2xs" />
        </div>
      </div>
    </div>
  </ContainerBasic>
</template>
<script setup lang="ts">
import ContainerBasic from '@/components/components/container-basic.vue';
import FaIcon from '@/components/fa-icon.vue';

const { t } = useTrans();

defineProps({
  url: {
    type: String,
    required: true,
  },
});

const isLoading = ref(true);

onMounted(() => {
  setTimeout(() => {
    window.addEventListener(
      'message',
      function (e) {
        const iframe = document.getElementById('personio-iframe');
        const eventName = e.data[0];
        const setHeight = e.data[1];
        const safetyGap = 60;
        switch (eventName) {
          case 'setHeight':
            iframe.style.height = setHeight + safetyGap + 'px';
            isLoading.value = false;
            break;
        }
      },
      false,
    );
  }, 100);
});
</script>
<style lang="postcss">
.header-container {
  @apply hidden;
}
</style>
